import React from 'react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { Box, Container, Typography } from '@mui/material';
import { useStyles } from './styles';
import CustomButton from 'components/CustomButton';

export default function Header() {
  const classes = useStyles();
  const router = useRouter();

  return (
    <div className={classes.root}>
      <Container>
        <div className={classes.content}>
          <div>
            <Typography component="h1" variant="h4">
              <b>
                Learn from those <br /> who have already <br /> discovered the power <br /> of
                infographics
              </b>
            </Typography>

            <Box mt={4}>
              <NextLink
                href={`/auth/login-register?from_url=${router.basePath + router.asPath}`}
                passHref={true}
              >
                <CustomButton>Start creating now</CustomButton>
              </NextLink>
            </Box>
          </div>

          <Box sx={{ width: 531 }}>
            <img src="/images/success-cases/header-success-cases.png" alt="Success cases image" />
          </Box>
        </div>
      </Container>
    </div>
  );
}
